export default "__VITE_ASSET__XRcsJkJA__"